<template>
  <draggable :list="elements" @change="handleElementDrag" handle=".el-move-action" :group="'elementList'+colIndex">
    <template v-for="(element, elIndex) in elements">
      <elementText
        :key="'text-element-'+elIndex"
        :data="element"
        :elindex="elIndex"
        :con-index="conIndex"
        :col-index="colIndex"
        :elements="elements"
        @elementUpdate="handleElementUpdate"
        @deleteElement="handleDeleteElement"
        v-if="element.type === 'text'"
      ></elementText>
      <elementDrop
        :key="'drop-element-'+elIndex"
        :data="element"
        :elindex="elIndex"
        :con-index="conIndex"
        :col-index="colIndex"
        :elements="elements"
        @deleteElement="handleDeleteElement"
        @elementUpdate="handleElementUpdate"
        @dropEdit="handleDropEdit"
        @updateData="handleUpdateData"
        v-else-if="element.type === 'drop'"
      ></elementDrop>
      <image-drop
        :key="'logo-element-'+elIndex"
        :data="element"
        :elindex="elIndex"
        :con-index="conIndex"
        :col-index="colIndex"
        :elements="elements"
        @deleteElement="handleDeleteElement"
        @updateImageSrc="handleUpdateImageSrc"
        v-else-if="element.type === 'logo' || element.type === 'image'"
      />
    </template>
  </draggable>
</template>

<script>
import elementText from './elementText'
import elementDrop from './elementDrop'
import imageDrop from './imageDrop'
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'
export default {
  components: {
    elementText,
    elementDrop,
    draggable,
    imageDrop
  },
  props: {
    elements: {
      type: Array,
      required: true
    },
    colIndex: Number,
    conIndex: Number
  },
  methods: {
    ...mapActions(['addFicheColonneElement', 'editFicheColonneTextElement', 'deleteFicheColonneTextElement', 'editFicheColonneDropElement', 'setAddedToFiche', 'updateElementOrder', 'updateElement', 'updateImageSrc']),
    handleAddElement (type) {
      this.addFicheColonneElement({conindex: this.conIndex, colindex: this.colIndex, type})
    },
    handleElementUpdate (data) {
      this.updateElement({conindex: this.conIndex, colindex: this.colIndex, ...data})
    },
    handleDeleteElement (elindex) {
      console.log('INSIDE')
      this.deleteFicheColonneTextElement({conindex: this.conIndex, colindex: this.colIndex, elindex})
    },
    handleDropEdit (data) {
      this.editFicheColonneDropElement({conindex: this.conIndex, colindex: this.colIndex, ...data})
    },
    handleUpdateData (data) {
      this.setAddedToFiche(data)
    },
    handleElementDrag () {
      this.updateElementOrder({conindex: this.conIndex, colindex: this.colIndex, value: this.elements})
    },
    handleUpdateImageSrc (data) {
      this.updateImageSrc({conindex: this.conIndex, colindex: this.colIndex, ...data})
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/listElement.vue